module.exports = __webpack_public_path__ + "img/home_mashangjijian_hover.90903c3.webp";